import { useCallback, useMemo } from 'react';

import map from 'lodash/map';

import { useShiftTypesByPositionIdGet } from '@sbv-clients/data-access-api';
import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import useAutoSelectValue from './util/use-auto-select-value';

export function ShiftTypeByPositionFilter({
  autoSelectIfEmpty,
  useContextFn,
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    positionId: number;
    shiftTypeId: number;
    setShiftTypeId: (value: number) => void;
  };
}) {
  const { positionId, shiftTypeId, setShiftTypeId } = useContextFn();
  const { data, isFetching, isSuccess } = useShiftTypesByPositionIdGet({
    positionId,
  });

  const options = useMemo(() => {
    const shiftTypes = data?.data?.data ?? [];
    return map(shiftTypes, (item) => ({
      id: String(item.shiftTypeId),
      label: item.shiftTypeName ?? '',
      value: item.shiftTypeId as number,
    }));
  }, [data?.data?.data]);

  const onChange = useCallback(
    (value: number) => {
      setShiftTypeId(value);
    },
    [setShiftTypeId]
  );

  const handleChange = useTransformSelectValue<number>(onChange);
  useAutoSelectValue({
    value: shiftTypeId,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess,
  });

  const needsPositionId = positionId === 0;
  return (
    <Select
      helperText={'Select a position first'}
      disabled={needsPositionId}
      isLoading={!needsPositionId && isFetching}
      fullWidth
      size="small"
      value={needsPositionId || isFetching ? '' : shiftTypeId}
      label="Shift Type"
      options={options}
      onChange={handleChange}
    />
  );
}
